import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';

const FileViewDownload = ({ imageData, fileMime, cancelPic }) => {
    // Initialize state with screen dimensions
    const [dimensions, setDimensions] = useState({
        width: window.screen.width > 1200 ? 600 : window.screen.width,
        height: window.screen.width > 1200 ? 800 : window.screen.height * 0.5,
    });
    const [isMobile, setIsMobile] = useState(false);
    const [mimeType, setMimeType] = useState('');

    const getMimeType = (filePath) => {
        const extension = filePath.split('.').pop().toLowerCase();
        const mimeTypes = {
          jpg: 'image/jpeg',
          jpeg: 'image/jpeg',
          png: 'image/png',
          gif: 'image/gif',
          pdf: 'application/pdf',
          doc: 'application/msword',
          docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
          txt: 'text/plain',
          html: 'text/html',
          csv: 'text/csv',
          json: 'application/json',
          mp4: 'video/mp4',
          mp3: 'audio/mpeg',
        };
        return mimeTypes[extension] || 'application/octet-stream';
      }

    useEffect(() => {
        // Mobile browser detection function
        const mobileCheck = () => {
            let check = false;
            (function(a){
                if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) 
                    check = true;
            })(navigator.userAgent||navigator.vendor||window.opera);
            return check;
        };
        
        setIsMobile(window.screen.width < 1200 || mobileCheck());
        console.log('MobileCheck2: ', window.screen.width < 1200, mobileCheck());
        setMimeType(getMimeType(fileMime));
    }, []);

    const downloadFile = () => {
        const a = document.createElement("a");
        a.href = `data:application/octet-stream;base64,${imageData}`;
        a.download = fileMime.split('/').pop();
        a.click();
        cancelPic();
    };

    // Determine content height based on mobile status
    const contentHeight = isMobile ? dimensions.height : dimensions.height * 0.8;

    return (
        <div className='cameraModal'>
            <div className="fileDisplayDiv" style={{ width: dimensions.width }}>
                <div className='fileInnerDiv' style={{ width: dimensions.width, height: dimensions.height }}>
                    <div style={{ 
                        display: "flex", 
                        flexDirection: "column", 
                        justifyContent: "start", 
                        alignItems: "flex-start", 
                        marginTop: isMobile ? '58px' : '19px' 
                    }}>
                        <div className="VideoAndCanvas" style={!isMobile ? { width: dimensions.width, height: dimensions.height } : {}}>
                            {mimeType.includes('image') ? (
                                <img 
                                    src={`data:${mimeType};base64,${imageData}`} 
                                    width={dimensions.width} 
                                    height={contentHeight} 
                                    alt="File preview" 
                                    style={{ objectFit: 'contain' }} 
                                />
                            ) : (
                                <div style={{ height: '86vh' }}>
                                    <iframe 
                                        src={`data:${mimeType};base64,${imageData}`} 
                                        width={dimensions.width} 
                                        height={contentHeight}
                                        title="File preview" 
                                        style={{ height: '100%' }} 
                                    />
                                </div>
                            )}
                        </div>
                        
                        <div className='cameraCaptureButtons' style={
                            isMobile 
                                ? { width: dimensions.width * 0.5, zIndex: 3025, position: 'fixed', left: '25%', top: '25%' } 
                                : { width: dimensions.width * 0.5 }
                        }>
                            <Button variant="contained" color="primary" className="ButtonShadow" onClick={downloadFile}>
                                Download
                            </Button>
                            <Button variant="contained" color="secondary" className="ButtonShadow" onClick={cancelPic}>
                                Close
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FileViewDownload;